// Límites de caracteres de los campos de texto de mesa de ayuda.
// Deben coincidir con las validaciones del API (HelpdeskTicketController).
export const TEXT_LIMITS = {
  description: 255,
  comment: 1000,
  rootCause: 2000,
  analysis: 2000,
};
